import { Avatar, AvatarGroup, Toolbar } from "@mui/material";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "stores";
import { getRoomMemberById } from "stores/modules/entities.room.members/selectors";
import { getCurrentMessageGroup } from "stores/modules/entities.rooms/selectors";

const ChatMembers = () => {
  const group = useAppSelector(getCurrentMessageGroup);
  const [t] = useTranslation();

  if (!group || group.kind === "public") {
    return null;
  }

  return (
    <Toolbar variant="dense" sx={{ minHeight: "40px" }}>
      <AvatarGroup
        max={10}
        componentsProps={{
          additionalAvatar: {
            sx: { width: 24, height: 24, fontSize: "12px" },
          },
        }}
        role="group"
        aria-label={t("チャットに参加中のユーザー")}
      >
        {group.uids.map((memberId) => (
          <MemberAvatar key={memberId} memberId={memberId} />
        ))}
      </AvatarGroup>
    </Toolbar>
  );
};

type MemberAvatarProps = {
  memberId: string;
};

const MemberAvatar = ({ memberId }: MemberAvatarProps) => {
  const member = useAppSelector((state) => getRoomMemberById(state, memberId));
  if (!member) {
    return null;
  }

  return (
    <Avatar
      sx={{ width: 24, height: 24, fontSize: "12px" }}
      alt={member.displayName}
      src={member.photoUrl || "/ccfolia.png"}
      imgProps={{ draggable: false }}
    />
  );
};

export default memo(ChatMembers);
